const parseBooleanFlag = (value: string | undefined) => value?.trim().toLowerCase() === 'true';

export const ASSISTANT_PANEL_ENABLED = parseBooleanFlag(import.meta.env.VITE_ASSISTANT_PANEL);
export const ADMIN_PANEL_ENABLED = parseBooleanFlag(import.meta.env.VITE_ENABLE_ADMIN_PANEL);
export const WORKSPACE_FEATURE_ENABLED = parseBooleanFlag(import.meta.env.VITE_ENABLE_WORKSPACE);
export const STORYBOARDS_FEATURE_ENABLED = parseBooleanFlag(import.meta.env.VITE_ENABLE_STORYBOARDS);
export const FOLDERS_FEATURE_ENABLED =
  WORKSPACE_FEATURE_ENABLED && parseBooleanFlag(import.meta.env.VITE_ENABLE_FOLDERS);
